import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteMyMonitoringSiteDetails = async (id: number): Promise<boolean> =>
  axios.delete(`/my-monitoring/sites/ClearSiteDetails?siteId=${id}`).then((res) => res?.data?.result)

type Props = {
  id: number
}

export const useMyMonitoringDeleteSiteDetails = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteMyMonitoringSiteDetails'],
    mutationFn: ({ id }: Props) => deleteMyMonitoringSiteDetails(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted site details.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to delete site details, please try again.')
      }
    },
    throwOnError: false
  })
